<template>
  <div class="loading" :class="$store.state.theme">
    <div class="centered">
      <div v-if="error">
        <i class="fa fa-kiwi-bird fa-3x has-text-warning" />
        <div class="has-text-danger is-size-3" style="margin-bottom: 12px">
          {{ error }}
        </div>
        <div class="has-text-link">{{ this.shortLink }}</div>
        <br />
        <span class="button is-primary has-text-weight-medium" @click="goHome"
          >Back to TUK</span
        >
      </div>
      <div v-else>
        <div v-if="isPicante()" class="picante-icon centered" />
        <div v-else class="tuk-icon centered" />
        <half-circle-spinner
          :animation-duration="1200"
          :size="190"
          color=" #209CEE"
        />
        <!-- color="#00ffbd" -->
        <!-- #209CEE -->
      </div>
    </div>
  </div>
</template>


<script>
import { HalfCircleSpinner } from "epic-spinners";

export default {
  name: "Loading",
  components: {
    HalfCircleSpinner,
  },
  data() {
    return {
      error: null,
      shortLink: null,
      loaderSize: Math.min(window.innerWidth * 0.75, window.innerHeight * 0.75),
    };
  },
  mounted() {
    // this.checkQuery();
    // this.shortLink = window.location;
    // console.log("short_link ID: ", shortID, this.$route);
    // var path = this.$route.path;
    // var shortID = this.$route.params.id;
    // if (!shortID) {
    // }
    // this.lookupShortLink(shortID);
  },
  activated() {
    console.log("LOADING");
    this.checkQuery();
  },
  methods: {
    checkQuery() {
      var query = this.$route.query;
      if (query.shop) {
        var shopID = query.shop;
        console.log("shopID", shopID);
        this.$store
          .dispatch("getAndSelectBusiness", shopID)
          .then(() => this.goto(`shop/${shopID}`))
          .catch((err) => this.apiError(err));
      }
    },
    goHome() {
      this.$router.push("/home");
    },
    lookupShortLink(shortID) {
      this.$store
        .dispatch("getShortLink", shortID)
        .then((res) => {
          this.console("getShortLink success", res);
          this.visitedShortLink(shortID);
          setTimeout(() => this.$router.push({ path: res.data.url }), 500); //400);
          // setTimeout(() => (this.error = "Invalid Link"), 2000); // testing invalid link
        })
        .catch((err) => {
          console.error("invalid short_link", err);
          this.error = "Invalid Link";
        });
    },
    visitedShortLink(shortID) {
      var data = { short_id: shortID, state: "visited" }; // mark link as visited
      this.$store
        .dispatch("patchShortLink", data)
        .then((res) => this.console("patchShortLink", res))
        .catch((err) => console.error("patchShortLink", err));
    },
  },
};
</script>

<style scoped>
.loading {
  background-color: #fac002;
  width: 100%;
  height: 100%;
}
.dark.loading {
  background-color: #1f1b24;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.tuk-icon {
  background-image: url("../../public/img/icons/round-512x512.png");
  /* background-color: #cccccc; */
  position: absolute;
  /* height: min(50vw, 50vh);
  width: min(50vw, 50vh); */
  height: 150px;
  width: 150px;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire */
}
.picante-icon {
  background-image: url("../../public/img/icons/picante_loading.svg");
  position: absolute;
  height: 150px;
  width: 150px;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
}
</style>